import * as types from '../constants/actionTypes';

// sagas
export const fetchTracks = query => ({
  type: types.FETCH_TRACKS,
  query,
});

// messages
export const fetchTracksLoading = () => ({ type: types.FETCH_TRACKS_LOADING });
export const fetchTracksError = () => ({ type: types.FETCH_TRACKS_ERROR });
export const fetchTracksSuccess = data => ({
  type: types.FETCH_TRACKS_SUCCESS,
  data,
});
